import FacturarPage from "./FacturarPage";

export {FacturarPage}
export default FacturarPage
